import React, { useState, useEffect, useRef } from "react";
import "../Header.css";
import { Link, NavLink } from "react-router-dom";
import {
    FaBars,
    FaTimes,
    FaChevronDown,
    FaPhoneAlt,
} from "react-icons/fa";

import logo from "../../assets/bluelotus-logo1.png";

const Header = () => {
    const [mobileMenu, setMobileMenu] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [activeDropdown, setActiveDropdown] = useState(null);

    const dropdownRef = useRef();

    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 80);
        };

        window.addEventListener("scroll", handleScroll);

        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        const closeMenu = (e) => {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(e.target)
            ) {
                setActiveDropdown(null);
            }
        };

        document.addEventListener("click", closeMenu);

        return () => {
            document.removeEventListener("click", closeMenu);
        };
    }, []);

    const companyMenu = [
        {
            title: "About Us",
            link: "/company/about",
        },
        {
            title: "Mission & Vision",
            link: "/company/mission",
        },
        {
            title: "Leadership",
            link: "/company/leadership",
        },
        {
            title: "Certifications",
            link: "/company/certifications",
        },
    ];

    const servicesMenu = [
        {
            title: "Managed Security",
            link: "/services/managed-security",
        },
        {
            title: "Cloud Security",
            link: "/services/cloud-security",
        },
        {
            title: "Network Security",
            link: "/services/network-security",
        },
        {
            title: "SOC Services",
            link: "/services/soc",
        },
        {
            title: "VAPT",
            link: "/services/vapt",
        },
        {
            title: "Compliance",
            link: "/services/compliance",
        },
    ];

    const solutionsMenu = [
        {
            title: "Banking",
            link: "/solutions/banking",
        },
        {
            title: "Healthcare",
            link: "/solutions/healthcare",
        },
        {
            title: "Manufacturing",
            link: "/solutions/manufacturing",
        },
        {
            title: "Government",
            link: "/solutions/government",
        },
        {
            title: "Education",
            link: "/solutions/education",
        },
        {
            title: "Retail",
            link: "/solutions/retail",
        },
    ];

    const resourcesMenu = [
        {
            title: "Blogs",
            link: "/resources/blogs",
        },
        {
            title: "Case Studies",
            link: "/resources/case-studies",
        },
        {
            title: "Whitepapers",
            link: "/resources/whitepapers",
        },
    ];

    const toggleDropdown = (menu) => {
        if (activeDropdown === menu) {
            setActiveDropdown(null);
        } else {
            setActiveDropdown(menu);
        }
    };

    return (
        <header className={scrolled ? "header scrolled" : "header"}>
            <div className="container header-container">

                {/* LOGO */}

                <Link to="/" className="logo" onClick={(e) => {
                    e.preventDefault();
                    window.location.href = "/";
                }}>
                    <img src={logo} alt="BlueLotus Logo" />
                </Link>

                {/* DESKTOP NAV */}

                <nav className="desktop-nav">

                    <NavLink to="/" end
                        onClick={(e) => {
                            e.preventDefault();
                            window.location.href = "/";
                        }}
                    >
                        Home
                    </NavLink>

                    <NavLink to="/about"
                        onClick={(e) => {
                            e.preventDefault();
                            window.location.href = "/about";
                        }}
                    >
                        About
                    </NavLink>

                    <NavLink to="/solutions"
                        onClick={(e) => {
                            e.preventDefault();
                            window.location.href = "/solutions";
                        }}
                    >
                        Solutions
                    </NavLink>

                    <NavLink to="/bluelotus-secureshield"

                        onClick={(e) => {
                            e.preventDefault();
                            window.location.href = "/bluelotus-secureshield";
                        }}
                    >
                        SecureShield
                    </NavLink>

                    <NavLink to="/contact"
                        onClick={(e) => {
                            e.preventDefault();
                            window.location.href = "/contact";
                        }}
                    >
                        Contact
                    </NavLink>

                </nav>

                {/* CTA BUTTON */}

                <div className="header-right">

                    <Link to="/consultation" className="consult-btn"

                        onClick={(e) => {
                            e.preventDefault();
                            window.location.href = "/consultation";
                        }}
                    >
                        <FaPhoneAlt />
                        <span>Get Consultation</span>
                    </Link>

                    {/* MOBILE MENU ICON */}

                    <button
                        className="mobile-toggle"
                        onClick={() => setMobileMenu(true)}
                    >
                        <FaBars />
                    </button>

                </div>

            </div>

            {/* MOBILE MENU */}

            <div className={mobileMenu ? "mobile-menu active" : "mobile-menu"}>

                <div className="mobile-header">
                    <img src={logo} alt="BlueLotus Logo" />

                    <button onClick={() => setMobileMenu(false)}>
                        <FaTimes />
                    </button>
                </div>

                <NavLink to="/" onClick={() => setMobileMenu(false)}>
                    Home
                </NavLink>

                <NavLink to="/about" onClick={() => setMobileMenu(false)}>
                    About
                </NavLink>

                <NavLink to="/solutions" onClick={() => setMobileMenu(false)}>
                    Solutions
                </NavLink>

                <NavLink to="/bluelotus-secureshield" onClick={() => setMobileMenu(false)}>
                    SecureShield
                </NavLink>

                <NavLink to="/contact" onClick={() => setMobileMenu(false)}>
                    Contact
                </NavLink>

                <Link
                    to="/consultation"
                    className="mobile-btn"
                    onClick={() => setMobileMenu(false)}
                >
                    Get Consultation
                </Link>

            </div>

        </header>
    );
};

export default Header;